import {call} from 'redux-saga/effects';
import {send} from './api';

export default (flows) => {
  flows.getFlow('send').setActions({
    onFetch: function* ({ payload }) {
      yield call(() => send(payload));
    },
  });

  return flows.getSagas();
};
